import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://acghvmyhjfusknmbfsgi.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFjZ2h2bXloamZ1c2tubWJmc2dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQzMDYwMTMsImV4cCI6MjA2OTg4MjAxM30.p17SwduyexkHaNT6mBywjVqLlvfLyLtfhxdlEkmCiIY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey) 